import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"back\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.702 4.734a.533.533 0 00-.754.007L1.145 7.594a.533.533 0 00.006.754l2.853 2.804a.533.533 0 10.748-.76L2.817 8.49l12.046-.105a.534.534 0 00-.01-1.067l-12.045.105L4.709 5.49a.534.534 0 00-.007-.755z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol